import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TextContent from '../components/TextContent'

ContentPage.propTypes = {
    
};

function ContentPage(props) {
    return (
        <>
            <Header></Header>
            <TextContent></TextContent>
            <Footer></Footer>
        </>
    );
}

export default ContentPage;